import { combineReducers } from 'redux';

import {
  GET_LIST_CHAT_LOADING,
  GET_LIST_CHAT_SUCCESS,
  GET_LIST_CHAT_ERROR,

  GET_MESSAGE_CHAT_LOADING,
  GET_MESSAGE_CHAT_SUCCESS,
  GET_MESSAGE_CHAT_ERROR,

  SEND_MESSAGE_CHAT_LOADING,
  SEND_MESSAGE_CHAT_SUCCESS,
  SEND_MESSAGE_CHAT_ERROR,

  GET_USER_TYPE_LOADING,
  GET_USER_TYPE_SUCCESS,
  GET_USER_TYPE_ERROR,

  GET_USER_ACTIVE_LOADING,
  GET_USER_ACTIVE_SUCCESS,
  GET_USER_ACTIVE_ERROR,

  CREAT_ROOM_CHAT_LOADING,
  CREAT_ROOM_CHAT_SUCCESS,
  CREAT_ROOM_CHAT_ERROR,
} from 'actions/liveChatAction';

const getListChatLoadingReducer = (state = false, action) => {
  switch (action.type) {
    case GET_LIST_CHAT_LOADING:
      return action.getListChatLoading;
    default:
      return state;
  }
};

const getListChatSuccessReducer = (state = false, action) => {
  switch (action.type) {
    case GET_LIST_CHAT_SUCCESS:
      return action.getListChatSuccess;
    default:
      return state;
  }
};

const getListChatDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_LIST_CHAT_SUCCESS:
      return action.getListChatData;
    default:
      return state;
  }
};

const getListChatErrorReducer = (state = false, action) => {
  switch (action.type) {
    case GET_LIST_CHAT_ERROR:
      return action.getListChatError;
    default:
      return state;
  }
};

const getMessageChatLoadingReducer = (state = false, action) => {
  switch (action.type) {
    case GET_MESSAGE_CHAT_LOADING:
      return action.getMessageChatLoading;
    default:
      return state;
  }
};

const getMessageChatSuccessReducer = (state = false, action) => {
  switch (action.type) {
    case GET_MESSAGE_CHAT_SUCCESS:
      return action.getMessageChatSuccess;
    default:
      return state;
  }
};

const getMessageChatDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_MESSAGE_CHAT_SUCCESS:
      return {
        data: action.getMessageChatData,
        email: action.email,
        keyRoom: action.keyRoom,
        friendId: action.friendId,
        namaPerusahaan: action.namaPerusahaan,
      };
    default:
      return state;
  }
};

const getMessageChatErrorReducer = (state = false, action) => {
  switch (action.type) {
    case GET_MESSAGE_CHAT_ERROR:
      return action.getMessageChatError;
    default:
      return state;
  }
};

const sendMessageChatLoadingReducer = (state = false, action) => {
  switch (action.type) {
    case SEND_MESSAGE_CHAT_LOADING:
      return action.sendMessageChatLoading;
    default:
      return state;
  }
};

const sendMessageChatSuccessReducer = (state = false, action) => {
  switch (action.type) {
    case SEND_MESSAGE_CHAT_SUCCESS:
      return action.sendMessageChatSuccess;
    default:
      return state;
  }
};

const sendMessageChatDataReducer = (state = {}, action) => {
  switch (action.type) {
    case SEND_MESSAGE_CHAT_SUCCESS:
      return {
        data: action.sendMessageChatData,
      };
    default:
      return state;
  }
};

const sendMessageChatErrorReducer = (state = false, action) => {
  switch (action.type) {
    case SEND_MESSAGE_CHAT_ERROR:
      return action.sendMessageChatError;
    default:
      return state;
  }
};

const getUserTypeLoadingReducer = (state = false, action) => {
  switch (action.type) {
    case GET_USER_TYPE_LOADING:
      return action.getUserTypeLoading;
    default:
      return state;
  }
};

const getUserTypeSuccessReducer = (state = false, action) => {
  switch (action.type) {
    case GET_USER_TYPE_SUCCESS:
      return action.getUserTypeSuccess;
    default:
      return state;
  }
};

const getUserTypeDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_USER_TYPE_SUCCESS:
      return {
        data: action.getUserTypeData,
      };
    default:
      return state;
  }
};

const getUserTypeErrorReducer = (state = false, action) => {
  switch (action.type) {
    case GET_USER_TYPE_ERROR:
      return action.getUserTypeError;
    default:
      return state;
  }
};

const getUserActiveLoadingReducer = (state = false, action) => {
  switch (action.type) {
    case GET_USER_ACTIVE_LOADING:
      return action.getUserActiveLoading;
    default:
      return state;
  }
};

const getUserActiveSuccessReducer = (state = false, action) => {
  switch (action.type) {
    case GET_USER_ACTIVE_SUCCESS:
      return action.getUserActiveSuccess;
    default:
      return state;
  }
};

const getUserActiveDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_USER_ACTIVE_SUCCESS:
      return {
        data: action.getUserActiveData,
      };
    default:
      return state;
  }
};

const getUserActiveErrorReducer = (state = false, action) => {
  switch (action.type) {
    case GET_USER_ACTIVE_ERROR:
      return action.getUserActiveError;
    default:
      return state;
  }
};

const createRoomChatLoadingReducer = (state = false, action) => {
  switch (action.type) {
    case CREAT_ROOM_CHAT_LOADING:
      return action.createRoomChatLoading;
    default:
      return state;
  }
};

const createRoomChatSuccessReducer = (state = false, action) => {
  switch (action.type) {
    case CREAT_ROOM_CHAT_SUCCESS:
      return action.createRoomChatSuccess;
    default:
      return state;
  }
};

const createRoomChatDataReducer = (state = {}, action) => {
  switch (action.type) {
    case CREAT_ROOM_CHAT_SUCCESS:
      return {
        data: action.createRoomChatData,
      };
    default:
      return state;
  }
};

const createRoomChatErrorReducer = (state = false, action) => {
  switch (action.type) {
    case CREAT_ROOM_CHAT_ERROR:
      return action.createRoomChatError;
    default:
      return state;
  }
};

const liveChatReducer = combineReducers({
  getListChatLoadingReducer,
  getListChatSuccessReducer,
  getListChatDataReducer,
  getListChatErrorReducer,

  getMessageChatLoadingReducer,
  getMessageChatSuccessReducer,
  getMessageChatDataReducer,
  getMessageChatErrorReducer,

  sendMessageChatLoadingReducer,
  sendMessageChatSuccessReducer,
  sendMessageChatDataReducer,
  sendMessageChatErrorReducer,

  getUserTypeLoadingReducer,
  getUserTypeSuccessReducer,
  getUserTypeDataReducer,
  getUserTypeErrorReducer,

  getUserActiveLoadingReducer,
  getUserActiveSuccessReducer,
  getUserActiveDataReducer,
  getUserActiveErrorReducer,

  createRoomChatLoadingReducer,
  createRoomChatSuccessReducer,
  createRoomChatDataReducer,
  createRoomChatErrorReducer,
})

export default liveChatReducer;
